import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import { Controller } from "react-hook-form";

const TextFieldController = ({
  name,
  control,
  label,
  required,
  errors,
  onChange,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    // rules={{required: true, minLength: 5, maxLength: 20}}
    render={({ field: { ref, onChange: _onChange, ...field }, fieldState }) => (
      <TextField
        {...field}
        label={
          required ? (
            <Grid container spacing={1}>
              <Grid item>
                <Typography color={"error"}>* </Typography>
              </Grid>
              <Grid item>
                <Typography color={"textPrimary"}>{label}</Typography>
              </Grid>
            </Grid>
          ) : (
            label
          )
        }
        InputLabelProps={
          required
            ? {
                required: false,
                shrink: true,
                error: false,
                focused: true,
              }
            : {}
        }
        required={required}
        inputRef={ref}
        error={errors.hasOwnProperty(name) && !!errors[name]}
        helperText={
          errors.hasOwnProperty(name)
            ? errors[name]["message"]
            : required
            ? field.value.trim() === "" && fieldState.isDirty
              ? "Requerido"
              : " "
            : rest.hasOwnProperty("FormHelperTextProps")
            ? " "
            : null
        }
        variant="standard"
        fullWidth
        {...rest}
        onChange={({ target: { value } }) => {
          _onChange(value);

          if (onChange) {
            onChange(value);
          }
        }}
      />
    )}
  />
);

export default TextFieldController;
